import {GET_SUB,GET_CASHOUT} from '../data/payment_data';

const initialState ={
date:null,
plan:null,
price:null,
totalViews:null,
pCount:null
}

export default (state=initialState,actions) =>{
  switch (actions.type) {
    case GET_SUB:
      return{
        ...state,
        date:actions.date,
        plan:actions.plan,
        price:actions.price
      }

case GET_CASHOUT:
      return{
        ...state,
        totalViews:actions.TotalViews,
pCount:actions.pCount
      }
  }
  return state;
}
